import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';
import DSSpinner from '@elliemae/ds-spinner';
import DSOverlay from '@elliemae/ds-overlay';

var blockName = 'loading-indicator';
var Container = aggregatedClasses('div')(blockName);

var DSLoadingIndicator = function DSLoadingIndicator(_ref) {
  var innerRef = _ref.innerRef,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'l' : _ref$size,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? null : _ref$message,
      _ref$hasBackdrop = _ref.hasBackdrop,
      hasBackdrop = _ref$hasBackdrop === void 0 ? true : _ref$hasBackdrop,
      _ref$onClickOutside = _ref.onClickOutside,
      onClickOutside = _ref$onClickOutside === void 0 ? function () {
    return null;
  } : _ref$onClickOutside,
      spinner = _ref.spinner,
      rest = _objectWithoutProperties(_ref, ["innerRef", "size", "loading", "message", "hasBackdrop", "onClickOutside", "spinner"]);

  var spinnerComponent = spinner || /*#__PURE__*/React.createElement(DSSpinner, _extends({
    innerRef: innerRef,
    message: message,
    size: size
  }, rest));
  return /*#__PURE__*/React.createElement(DSOverlay, {
    backDropZIndex: 200 // https://jira.elliemae.io/browse/PUI-1712
    ,
    hasBackdrop: hasBackdrop,
    isOpen: loading,
    onClickOutside: onClickOutside
  }, /*#__PURE__*/React.createElement(Container, null, spinnerComponent));
};

var loadingIndicatorProps = {
  innerRef: PropTypes.func.description('Get spinner reference'),
  size: PropTypes.oneOf(['s', 'm', 'l']).description('Size of the spinner').defaultValue('l'),
  loading: PropTypes.bool.description('Whether to show the spinner or not').defaultValue(false),
  message: PropTypes.string.description('Message below the spinner'),
  hasBackdrop: PropTypes.bool.description('Show a backdrop besides the spinner').defaultValue(true),
  onClickOutside: PropTypes.func.description('Handler when a user clicks the outside the spinner'),
  spinner: PropTypes.element.description('Render a custom spinner (JSX)')
};
DSLoadingIndicator.propTypes = loadingIndicatorProps;
var LoadingIndicatorWithSchema = describe(DSLoadingIndicator);
LoadingIndicatorWithSchema.propTypes = loadingIndicatorProps;

export default DSLoadingIndicator;
export { DSLoadingIndicator, LoadingIndicatorWithSchema };
//# sourceMappingURL=DSLoadingIndicator.js.map
